<div
  class="auto-suggest-item"
  *ngFor="let item of dataList; let i = index"
  [ngClass]="{'selected': selectedIndex === i}"
  (click)="click(item)"
>
  <div class="key">{{ item.name }}</div>
  <div class="operator">{{ item.operator }}</div>
  <div class="value">{{ item.operands }}</div>
</div>
